import React, { useEffect, useState } from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";
import Tooltip from "@material-ui/core/Tooltip";
import exclamationcircleblue from "../../Assets/exclamationcircleblue.svg";
import "./RadioButtons.styles.scss";

function RadioButtons(props) {
  const {
    label,
    name,
    options,
    present,
    isRow,
    required,
    disabled,
    onValChange,
    ...rest
  } = props;

  const [showTextBox, setShowTextBox] = useState(false);

  const toggleOtherChecked = () => {
    setShowTextBox(true);
  };
  const hideOtherChecked = () => {
    setShowTextBox(false);
  };
  const onClickFunc = (option, field) => {
    if (option.key === "Other") { toggleOtherChecked(); }
    else { hideOtherChecked() }
    if(onValChange) onValChange(option.value)
  }
  return (
    <div className="">
      <label className="xs-lable-select white" required>
        {label}
        {required ? <span style={{ color: "red" }}>{` *`}</span> : null}
      </label>
      <div
        style={{
          display: "flex",
          flexDirection: isRow ? "row" : "column",
          marginBottom: "2em",
        }}
      >
        <Field name={name}>
          {({ field, form: { setFieldValue } }) => {
            return options.map((option) => {
              return (
                <div key={option.key} style={{ marginRight: "2em" }}>
                  <input
                    type="radio"
                    id={option.key}
                    {...field}
                    {...rest}
                    disabled={disabled}
                    value={option.value}
                    checked={
                      option.key !== "Other"
                        ? field.value === option.value
                        : !present.includes(field.value)
                    }
                    onClick={() => {
                      onClickFunc(option, field)
                    }}
                    style={{
                      color: `${disabled ? "#707070" : "white"}`,
                      opacity: `${disabled ? "0.4" : "1"}`,
                    }}
                  />
                  <label
                    className={`radio_label ${field.value === option.value ? "active_radio" : ""
                      }`}
                    style={disabled ? { color: "#707070" } : null}
                    htmlFor={option.key}
                  >
                    {option.key} {props.role !== undefined && props.role === option.value ? <span className="current-role-text">(Current Role)</span> : ""}
                  </label>
                  {option.key === "Other" && showTextBox ? (
                    <input
                      className="other-input"
                      type="text"
                      maxLength="3"
                      {...field}
                      disabled={disabled}
                      value={field.value}
                      onChange={(e) => {
                        setFieldValue(name, e.target.value);
                      }}
                      style={{
                        fontSize: "12px",
                        color: `${disabled ? "#707070" : "white"}`,
                        opacity: `${disabled ? "0.7" : "1"}`,
                      }}
                    // disabled={present.includes(field.value)}
                    />
                  ) : null}
                  {option.info && <Tooltip title={option.info} placement="right">
                    <img
                      src={exclamationcircleblue}
                      alt="logo"
                      // className="fluid logo"
                      style={{
                        width: "0.7rem",
                        height: "0.7rem",
                        cursor: "pointer",
                        marginLeft: "0.25rem",
                      }}
                    />
                  </Tooltip>}
                  {/* {option.info && <img src="/static/media/exclamationcircleblue.cc6d5acc.svg" alt="logo" className={"icon-info"} title={option.info}></img>} */}
                </div>
              );
            });
          }}
        </Field>
        <ErrorMessage component={TextError} name={name} />
      </div>
    </div>
  );
}

export default RadioButtons;
